import { render, staticRenderFns } from "./HandleDetail.vue?vue&type=template&id=d023da66&scoped=true&"
import script from "./HandleDetail.vue?vue&type=script&lang=js&"
export * from "./HandleDetail.vue?vue&type=script&lang=js&"
import style0 from "./HandleDetail.vue?vue&type=style&index=0&id=d023da66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d023da66",
  null
  
)

export default component.exports